// src/components/Layout.js
import React from 'react';
import { Box, Container } from '@mui/material';
import NavigationBar from './NavigationBar';

const Layout = ({ children }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <NavigationBar />
      <Container sx={{ flexGrow: 1, py: 2 }}>
        {children}
      </Container>
    </Box>
  );
};

export default Layout;

